import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { NOTES_TEMPLATE_CONTROLLER } from "api/Service";

export const useCreateNoteTemplate = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (templateData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${NOTES_TEMPLATE_CONTROLLER}`,
        templateData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["noteTemplatesAll"] });
    },
  });
};
